let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6qTcV")).then(() => parcelRequire('f8cDr'));